import React from 'react';

export const DurationFormatter = ({ duration }: { duration: number }) => {
  const formatDuration = (duration: number) => {
    if (duration === undefined) {
      return '';
    }

    if (duration === 0 || duration === null) {
      return 0;
    }

    if (Math.abs(duration) < 60) {
      return `${duration}s`;
    }

    const preSign = duration < 0 ? -1 : 1;

    let tmp = Math.abs(duration);
    //const days = Math.floor(tmp / 86400);
    //tmp = tmp - days * 86400;

    const hours = Math.floor(tmp / 3600);
    tmp = tmp - hours * 3600;

    const minutes = Math.floor(tmp / 60);
    tmp = tmp - minutes * 60;

    let formattedDuration = preSign === -1 ? '- ' : ' ';

    /*
    if (days !== 0) {
      formattedDuration += `${days}d `;
    }
    */

    if (hours !== 0) {
      formattedDuration += `${hours}h `;
    }

    if (minutes !== 0) {
      formattedDuration += `${minutes}m `;
    }

    return formattedDuration;
  };

  return <span>{formatDuration(duration)}</span>;
};
